import { BACKEND_URL } from "./constants";
import store from "store/index";

export const me = () => {
  const state = store?.getState();
  return state?.Profile?.me;
};

export const TIME_ZONE = () => {
  return JSON.parse(localStorage.getItem("timezone"));
};

export const LOGO = () => {
  if (!me()?.company_logo) return "";
  if (me()?.company_logo == "undefined") return "";
  return `${BACKEND_URL}/${me()?.company_logo}` || "";
};

export const UPDATE_CLOCK_INTERVAL = 1000 * 60;
export const UPDATE_NOTIFICATION_INTERVAL = 1000 * 300;
